import { ADMIN_GROUP_FORM } from './index';
import { Action } from '../action';
import { AccessCodeGroupInfo } from '@shared/core';

export class AdminGroupFormInitAction implements Action {
	readonly type = ADMIN_GROUP_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupFormDestroyAction implements Action {
	readonly type = ADMIN_GROUP_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupFormClickAddOrganizationAction implements Action {
	readonly type = ADMIN_GROUP_FORM.CLICK_ADD_ORGANIZATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupFormClickSubmitAction implements Action {
	readonly type = ADMIN_GROUP_FORM.CLICK_SUBMIT;
	constructor(
		public payload: AccessCodeGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminGroupFormUpdateAction implements Action {
	readonly type = ADMIN_GROUP_FORM.UPDATE;
	constructor(
		public payload: AccessCodeGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminGroupFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_GROUP_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupFormUpdateFailureAction implements Action {
	readonly type = ADMIN_GROUP_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupFormAddAction implements Action {
	readonly type = ADMIN_GROUP_FORM.ADD;
	constructor(
		public payload: AccessCodeGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminGroupFormAddSuccessAction implements Action {
	readonly type = ADMIN_GROUP_FORM.ADD_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupFormAddFailureAction implements Action {
	readonly type = ADMIN_GROUP_FORM.ADD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
